/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";
import { PaginatedResponse, SentReviewData, ReceivedReviewData, SentReviewsResponse, ReceivedReviewsResponse } from "./types";

type RatingsState = {
  sentReviews: PaginatedResponse<SentReviewData>;
  receivedReviews: PaginatedResponse<ReceivedReviewData>;
  loading: boolean;
};

const initialState: RatingsState = {
  sentReviews: {
    total: 0,
    per_page: 30,
    current_page: 1,
    last_page: 1,
    first_page: 1,
    first_page_url: "/?page=1",
    last_page_url: "/?page=1",
    next_page_url: null,
    previous_page_url: null,
    data: [],
  },
  receivedReviews: {
    total: 0,
    per_page: 30,
    current_page: 1,
    last_page: 1,
    first_page: 1,
    first_page_url: "/?page=1",
    last_page_url: "/?page=1",
    next_page_url: null,
    previous_page_url: null,
    data: [],
  },
  loading: false,
};

export const reviewSlice = createSlice({
  name: "review",
  initialState,
  reducers: {
    setSentReviews: (state, action) => {
      state.sentReviews = action.payload;
    },

    resetSentReviews: (state) => {
      state.sentReviews = initialState.sentReviews;
    },

    setReceivedReviews: (state, action) => {
      state.receivedReviews = action.payload;
    },

    resetReceivedReviews: (state) => {
      state.receivedReviews = initialState.receivedReviews;
    },

    setLoading: (state, action) => {
      state.loading = action.payload; // Update loading state
    },
  },
});

export const { setSentReviews, resetSentReviews, setReceivedReviews, resetReceivedReviews, setLoading } = reviewSlice.actions;

export default reviewSlice.reducer;